<template>
  <div class="base-loading">
    <div v-if="waitFlg" class="overlay">
      <div class="loading">
        <div class="text">{{ loadingText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoading',

  props: {
    waitFlg: { type: Boolean, default: false }
  },

  data() {
    return {
      elapsedSeconds: 0,
      intervalId: null
    }
  },

  computed: {
    loadingText() {
      const baseText = 'Loading'
      const dotPattern = [3, 0, 1, 2]
      const secondsIndex = this.elapsedSeconds % 4
      const dotCount = dotPattern[secondsIndex]
      return `${baseText}${'.'.repeat(dotCount)}`
    }
  },

  watch: {
    waitFlg: {
      handler(newVal) {
        if (newVal) {
          this.startTimer()
        } else {
          this.stopTimer()
        }
      },
      immediate: true
    }
  },

  beforeDestroy() {
    this.stopTimer()
  },

  methods: {
    startTimer() {
      this.intervalId = setInterval(() => {
        this.elapsedSeconds++
      }, 1000)
    },
    stopTimer() {
      clearInterval(this.intervalId)
      this.elapsedSeconds = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.base-loading {
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(45, 45, 45, 0.1);
    z-index: 10000;
    > .loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 260px;
      > .text {
        padding-left: 16px;
        color: white;
        font-size: 50px;
        text-align: left;
        text-shadow: 1px 0 5px black;
      }
    }
  }
}
</style>
